import { setProcessing } from './uiSlice'

let globalProcessingTimer = null
let processingTriggered = false

export const processingDelayMiddleware = (store) => (next) => (action) => {
  const result = next(action)
  const type = action.type

  if (type.endsWith('/pending')) {
    const state = store.getState()
    const activeRequests = state.uiSlice?.activeRequests ?? 0

    // Start a single 500ms delay timer if it's the first pending call
    if (activeRequests === 1 && !globalProcessingTimer) {
      globalProcessingTimer = setTimeout(() => {
        const stateCheck = store.getState()
        if (
          stateCheck.uiSlice?.activeRequests > 0 &&
          !processingTriggered
        ) {
          store.dispatch(setProcessing(true))
          processingTriggered = true
        }
        globalProcessingTimer = null
      }, 500)
    }
  }

  if (type.endsWith('/fulfilled') || type.endsWith('/rejected')) {
    const state = store.getState()
    const activeRequests = state.uiSlice?.activeRequests ?? 0

    // When all requests complete, reset everything
    if (activeRequests === 0) {
      clearTimeout(globalProcessingTimer)
      globalProcessingTimer = null
      processingTriggered = false
      store.dispatch(setProcessing(false))
    }
  }

  return result
}